import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { AppState } from "@app/reducers";
import { adjustDateFormatAsPerPCalendar, CrudService, CustomDirectiveConfig, IApplicationResponse, ModulesBasedApiSuffix, RxjsService, setRequiredValidator } from "@app/shared";
import { DealerBranchCategoryDetailModel, DealerModuleApiSuffixModels } from '@modules/dealer';
import { loggedInUserData } from "@modules/others";
import { UserLogin } from "@modules/others/models";
import { select, Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/api";
@Component({
  selector: 'app-dealer-billing-info-modal',
  templateUrl: './dealer-billing-info-modal.component.html'
})

export class DealerBillingInfoModalComponent implements OnInit {
  dealerBillingInfoForm: FormGroup;
  loggedUser
  dateFormat = adjustDateFormatAsPerPCalendar();
  dealerCategoryList = [];
  isADecimalMaxTwoDigitsTwoDecimals = new CustomDirectiveConfig({ isADecimalMaxTwoDigitsTwoDecimals: true, shouldPasteKeyboardEventBeRestricted: true });
  isANumberZeroToNinetyNine = new CustomDirectiveConfig({ isANumberZeroToNinetyNine: true, shouldPasteKeyboardEventBeRestricted: true });

  constructor(private rxjsService: RxjsService, public config: DynamicDialogConfig, public ref: DynamicDialogRef, private store: Store<AppState>,
    private crudService: CrudService, private formBuilder: FormBuilder) {
    this.rxjsService.setDialogOpenProperty(true);
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.loggedUser = userData;
    });
  }
  ngOnInit(): void {
    this.initForm();
    this.onLoadDealerCategory();
  }

  initForm(dealerBranchCategoryDetailModel?: DealerBranchCategoryDetailModel) {
    let dealerBillingInfoModel = new DealerBranchCategoryDetailModel(dealerBranchCategoryDetailModel);

    this.dealerBillingInfoForm = this.formBuilder.group({});
    Object.keys(dealerBillingInfoModel).forEach((key) => {
      this.dealerBillingInfoForm.addControl(key, new FormControl(dealerBillingInfoModel[key]));
    });
    this.dealerBillingInfoForm = setRequiredValidator(this.dealerBillingInfoForm, ["dealerCategoryTypeId", "purchaseMultiples", "dsfValue", "commissionPercentage", "technicalWarrantyMonths", "financialWarrantyMonths", "effectiveFrom"]);
    if (this.config?.data) {
      let dealerBillingInfoModel = new DealerBranchCategoryDetailModel(this.config.data);
      this.dealerBillingInfoForm.patchValue(dealerBillingInfoModel);
      this.dealerBillingInfoForm.get('effectiveFrom').setValue(this.config?.data?.effectiveFrom ? new Date(this.config?.data?.effectiveFrom) : new Date());
    }
    this.onFormControlChanges();
  }

  onLoadDealerCategory() {
    this.crudService.dropdown(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.UX_DEALER_BRANCH_CATEGORY_COMMISSION_TYPE)
      .subscribe((response: IApplicationResponse) => {
        if (response?.isSuccess && response?.statusCode == 200) {
          this.dealerCategoryList = response?.resources;
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      })
  }

  onFormControlChanges() {
    this.dealerBillingInfoForm.get('dealerCategoryTypeId').valueChanges.subscribe((dealerCategoryTypeId: string) => {
      if (dealerCategoryTypeId) {
        this.dealerCategoryList.filter(category => {
          if (category.id == dealerCategoryTypeId) {
            this.dealerBillingInfoForm.patchValue({
              clientDescription: category.description,
            });
          }
        });
      }
    });
  }
  onSubmitDialog() {
    if (this.dealerBillingInfoForm.invalid) {
      return
    }
    else {
      let dealerBillingInfoModel = new DealerBranchCategoryDetailModel(this.dealerBillingInfoForm.value);
      this.ref.close(dealerBillingInfoModel);
    }
  }
  
  btnCloseClick() {
    this.rxjsService.setDialogOpenProperty(false);
    this.ref.close(false);
  }
}